export enum CreateCompanyStep {
  CompanyDetails = 1,
  Authentication = 2,
  AddLicense = 3,
}
